module.exports = __webpack_public_path__ + "static/media/2 (14).c72b727b.jpg";